<template>
    <Breadcrumbs title="User Cards" main="Users" />

    
</template>

<script>

export default {
    name: 'userCards',
    components: {
        
    }
}
</script>
